import React from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_SEO_GEOENTITY } from '../../routes'
import { selectFirstAddress } from '../../store/address/address.selectors'
import { selectCurrentGeoentityId, selectGeoentities } from '../../store/geoentity/geoentity.selectors'
import { selectGeoentityTypeDataForSearch } from '../../store/poiassets/poiassets.selectors'
import { selectShouldDisplayListItemData, selectTownFromPath } from '../../store/seo/seo.selectors'
import JsonLd from '../genericComponents/JsonLD'
import { generateFullRoute } from '../router/routeUtils'
import { withEverySelectorTruthy } from '../utils/react-redux'
import { getStructuredAggregateRating, getStructuredBusinessType, getStructuredImage } from './GeoentityStructuredData'

const getItems = (geoentities, currentGeoentityId) =>
  geoentities
    .filter(({ id }) => id !== currentGeoentityId)
    .map((poi, idx) => {
      const { id, name, rubric, additionalInfo, reviews } = poi
      const imageUrl = additionalInfo?.illustration?.url

      return {
        '@type': 'ListItem',
        position: idx + 1,
        item: {
          ...getStructuredBusinessType(rubric?.id),
          name,
          url: generateFullRoute(ROUTE_SEO_GEOENTITY, { geoentityId: id }),
          ...getStructuredImage(imageUrl),
          ...(currentGeoentityId ? {} : getStructuredAggregateRating(reviews))
        }
      }
    })

const GeoentityListStructuredData = () => {
  const geoentities = useSelector(selectGeoentities)
  const currentGeoentityId = useSelector(selectCurrentGeoentityId)
  const { town } = useSelector(selectFirstAddress)
  const { zip } = useSelector(selectTownFromPath)
  const { label } = useSelector(selectGeoentityTypeDataForSearch)

  if (!geoentities) return <></>

  const name = label && town ? { name: `${label} à ${town} ${zip}, France` } : {}

  const data = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    ...name,
    itemListElement: getItems(geoentities, currentGeoentityId)
  }

  return <JsonLd data={data} />
}

export default withEverySelectorTruthy(selectShouldDisplayListItemData)(GeoentityListStructuredData)
